module.exports = __webpack_public_path__ + "static/media/banner.b718272d.png";